import { getAbsences, getHolidays } from "../../../api/users";
import { showToastError } from "../../../services/toast";
import { useProductionStore } from "../../../stores/production";

const HolidaysOrAbsence = () => {
    const { formData, setProduction2, setIsLoading } = useProductionStore();

    const handleHolidaysOrAbsences = (getHolidaysOrAbsencesFunction: (date: string) => Promise<any>) => {
        if (!formData.date) {
            showToastError("Veuillez sélectionner un mois avant de continuer.");
            return;
        }

        setIsLoading(true);
        getHolidaysOrAbsencesFunction(formData.date)
            .then((res) => {
                setProduction2(res.data);
            })
            .catch((error) => {
                console.error("Erreur lors de la récupération des données:", error);
                showToastError("Une erreur est survenue lors de la récupération des données.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const handleSend1 = () => handleHolidaysOrAbsences(getHolidays);
    const handleSend2 = () => handleHolidaysOrAbsences(getAbsences);

  return (
    <div className='flex justify-start items-center'>
        <button
            className="w-44 bg-linear-to-r   from-blue-600 to-dca-blue opacity-80 text-white p-2 rounded-lg hover:opacity-100 cursor-pointer font-Nunito transition-all duration-300 flex justify-center items-center mr-2"
            onClick={() => handleSend1()}
        >
            Congés
        </button>
        <button
            className="w-44 bg-linear-to-r   from-blue-600 to-dca-blue opacity-80 text-white p-2 rounded-lg hover:opacity-100 cursor-pointer font-Nunito transition-all duration-300 flex justify-center items-center mr-2"
            onClick={() => handleSend2()}
        >
            Absence
        </button>
    </div>
  )
}

export default HolidaysOrAbsence